// src/components/icons/logo.js
import React from 'react';

const IconLogo = () => null;

export default IconLogo;
